<template>
  <v-dialog v-model="dialogStatus"
            persistent
            max-width="800px">
    <div class="fill-height">


      <v-card class="fill-height">

        <v-card-subtitle> درخواست ویرایش واحد </v-card-subtitle>
        <v-spacer/>

        <v-card-text>


          <v-form  ref="form"  lazy-validation v-model="valid">

            <v-row>
              <v-col cols="12" md="4" class="text-right">
                <label> <span style="color: black"><strong>نام مجتمع:</strong></span><span class="mr-1">{{model.buildingName}}</span></label>
              </v-col>
              <v-col cols="12" md="4" class="text-right">
                <label><span style="color: black"><strong>نام واحد:</strong></span><span class="mr-1">{{model.unitName}}</span></label>
              </v-col>
              <v-col cols="12" md="4" class="text-right">
                <label> <span style="color: black"><strong>نام شخص:</strong></span><span class="mr-1">{{model.fullName}}</span></label>
              </v-col>
              <v-col cols="12" md="4" class="text-right">
                <label><span style="color: black"><strong>نوع:</strong></span><span class="mr-1">{{model.type}}</span></label>
              </v-col>
              <v-col cols="12" md="4" class="text-right">
                <label> <span style="color: black"><strong>موبایل:</strong></span><span class="mr-1">{{model.mobile}}</span></label>
              </v-col>
              <v-col cols="12" md="4" class="text-right">
                <label><span style="color: black"><strong>تاریخ استقرار:</strong></span><span class="mr-1">{{model.dateText}}</span></label>
              </v-col>


            </v-row>
            <v-divider class="p-3 m-3"/>
            <span style="float: right"><strong >مراحل:</strong></span>
            <v-row class="mx-2">
              <v-col md="12">
               <div id="style-1" style="height:300px;overflow-y: auto" >
                 <v-timeline
                     :reverse="true"
                     dense >
                   <v-timeline-item
                       color="grey"
                       icon-color="grey lighten-2"
                       small>

                     <v-row justify="space-between">

                       <v-col cols="7">
                         <span style="color: black">درخواست دهنده:</span><span class="mr-1">{{model.creatorUser}}</span>
                       </v-col>
                       <v-col
                           class="text-right"
                           cols="5">
                         <span style="color: black">تاریخ درخواست:</span> <span class="mr-1">{{model.requestDateTxt}}</span>
                       </v-col>
                     </v-row>

                   </v-timeline-item>
                   <v-timeline-item
                       color="grey"
                       icon-color="grey lighten-2"
                       small>

                     <v-row justify="space-between">

                       <v-col cols="7">
                         <span style="color: black">انجام دهنده:</span><span class="mr-1">{{model.name}}</span>
                       </v-col>
                       <v-col
                           class="text-right"
                           cols="5">
                         <span style="color: black">تاریخ انجام: </span> <span class="mr-1">{{model.lastResponseDateTx}}</span>

                       </v-col>
                     </v-row>

                   </v-timeline-item>
                 </v-timeline>
               </div>

              </v-col>

            </v-row>

            <v-divider class="p-1 m-1"/>
            <v-card-actions dir="ltr">

              <v-btn
                  small
                  depressed
                  color="error"
                  class=" pr-4 pl-4 m-1"
                  @click="closed"
              >
               بستن
              </v-btn>

            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>


export default {


  props: {
    dialogStatus: {
      default: false,
    },
    model: Object,
  },
  data() {
    return {
      valid: true,
    }
  },


  methods: {
    closed() {
      this.$root.$emit('UnitEditReport')
      this.$emit('update:dialogStatus', false)
    },

  },



}
</script>


